import PcPayBox from "./pc/index.vue";
import MobilePayBox from "./m/index.vue";
import { createApp } from "vue";

import { ref } from "vue";
import { getOverseasPayList } from "~/api/api";
// import router from "~/router"; // Nuxt.js uses file-based routing, use navigateTo or useRouter instead
import { useLoading } from "~/hooks/useLoading";
import { checkPay } from "@/api/user";
import showMessage from "@/utils/showMessage";
import usePixel from "~/hooks/usePixel";

const { startLoading, stopLoading } = useLoading();

const tPay = (key, fallback = "") => {
	try {
		const { $i18n } = useNuxtApp();
		const text = $i18n?.t?.(key);
		return text && text !== key ? text : fallback;
	} catch (error) {
		return fallback;
	}
};

// 获取地区支付列表
const areaPayment = ref([]);
getOverseasPayList({
	type: 3,
}).then(res => {
	areaPayment.value = res.data.area_payment;
});

function getCurrentPathAndParams() {
	if (import.meta.client) {
		const url = new URL(window.location.href);
		const path = url.pathname;
		let query = new URLSearchParams(url.search);
		query = Object.fromEntries(query.entries());
		delete query.order_id;

		return {
			path,
			query,
		};
	}
	return { path: "/", query: {} };
}

const PayBox = {
	onSuccessCb: () => {},
	// 支付成功方法
	onSuccess: async res => {
		try {
			await navigateTo(getCurrentPathAndParams(), { replace: true });
			await navigateTo(`/seer/chat/${res.teacher_uid}`);
			PayBox.onSuccessCb();
		} catch (error) {
			console.error("导航失败:", error);
		}
	},
	// 弹起支付弹窗
	alter: (props, callback) => {
		const { $isMobile, $i18n } = useNuxtApp();
		const PayBoxComponent = $isMobile ? MobilePayBox : PcPayBox;
		const container = document.createElement("div");
		const payBox = createApp(PayBoxComponent, {
			...props,
			onSuccess: PayBox.onSuccess,
			areaPayment: areaPayment.value,
			close,
		});
		if ($i18n) {
			payBox.use($i18n);
		}
		open();
		function open() {
			payBox.mount(container);
			document.body.appendChild(container);
		}

		function close() {
			payBox.unmount(container);
			document.body.removeChild(container);
			if (typeof callback === "function") {
				callback();
			}
		}
	},
};

// 针对苹果原生浏览器这些支付回调后页面被刷新的情况，查单
const successData = ref({});
async function checkOrderStatus(orderId, retry = 10, ms = 3000) {
	if (retry < 0) return false;

	if (typeof retry !== "number") {
		retry = 10;
	}

	const { data } = await checkPay({
		order_ids: orderId,
	});

	if (!Array.isArray(data.list) || !data.list.length || data.list[0].status === 0) {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve(checkOrderStatus(orderId, retry - 1, ms));
			}, ms);
		});
	} else {
		successData.value = data.list[0];
		return data.list[0].status;
	}
}
const { reportPurchase } = usePixel();
const checkOrder = async ({ isReturnCheck }) => {
	isReturnCheck && startLoading(tPay("user.pc.wallet.checkingPayment", "支付查單中，請稍等"));
	const isPay = await checkOrderStatus(
		isReturnCheck ? orderId : localStorage.getItem("order_id"),
		isReturnCheck ? 3 : 40,
		isReturnCheck ? 1500 : 3000
	).finally(() => {
		isReturnCheck && stopLoading();
	});
	if (isPay) {
		// 第三方像素支付事件回传
		reportPurchase(successData.value.order_id, successData.value?.final_price);
		localStorage.removeItem("order_id");
		PayBox.onSuccess(successData.value);
	} else {
		isReturnCheck &&
			showMessage(tPay("user.pc.wallet.paymentNotFound", "未能查到支付信息，請稍後重試"), "error");
	}
};
function getOrderIdFromUrl() {
	if (import.meta.client) {
		const url = new URL(window.location.href);
		return url.searchParams.get("order_id");
	}
	return null;
}

// 只在客户端执行订单检查
const orderId = getOrderIdFromUrl();
if (import.meta.client) {
	if (orderId) {
		localStorage.removeItem("order_id");
		checkOrder({ isReturnCheck: true });
	} else if (localStorage.getItem("order_id")) {
		checkOrder({ isReturnCheck: false });
	}
}

export { PayBox };
